// ========================================================
// FAST HIT Website — How It Works Section
// 4-Step player & organizer progression flow
// ========================================================

import { UserPlus, Shield, Radio, Award } from 'lucide-react';
import './HowItWorks.css';

const STEPS = [
  {
    number: '01',
    icon: UserPlus,
    title: 'Create Your Player Profile',
    desc: 'Set up your cricket identity with batting & bowling styles, city, bio, and playing preferences in under 2 minutes.',
  },
  {
    number: '02',
    icon: Shield,
    title: 'Build or Join a Squad',
    desc: 'Connect with local teammates, manage your club roster, assign captain roles, and prepare your match playing XI.',
  },
  {
    number: '03',
    icon: Radio,
    title: 'Score or Follow Live',
    desc: 'Record deliveries with authorized official scoring, or follow matches ball-by-ball with live commentary and instant updates.',
  },
  {
    number: '04',
    icon: Award,
    title: 'Climb Rankings & Tournaments',
    desc: 'Compete in league fixtures, automatically calculate Net Run Rates, and showcase achievements on player leaderboards.',
  },
];

export function HowItWorks() {
  return (
    <section className="how-it-works" aria-labelledby="how-it-works-title">
      <div className="how-it-works__container">
        {/* Header */}
        <div className="how-it-works__header text-center">
          <div className="section-eyebrow">
            <span>Simple 4-Step Flow</span>
          </div>
          <h2 id="how-it-works-title" className="section-title">
            How FAST HIT Powers Your Cricket Journey
          </h2>
          <p className="section-subtitle mx-auto">
            From casual weekend matches to regulated league tournaments — we make match management seamless.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="how-it-works__grid">
          {STEPS.map((step) => {
            const Icon = step.icon;
            return (
              <div key={step.number} className="step-card">
                <div className="step-card__badge-row">
                  <span className="step-card__number">{step.number}</span>
                  <div className="step-card__icon-box">
                    <Icon size={20} />
                  </div>
                </div>

                <h3 className="step-card__title">{step.title}</h3>
                <p className="step-card__desc">{step.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
